import type { PortableTextComponents } from "@portabletext/react";
import type { CreateRichTextComponentsOptions } from "./types";

import {
  createDefaultBlockComponents,
  createDefaultListComponents,
  createDefaultListItemComponents,
} from "./default-block-components";
import {
  createDefaultMarkComponents,
  createDefaultTypeComponents,
} from "./default-mark-and-type-components";
import { mergePortableTextComponents } from "./merge-portable-text-components";

const DEFAULT_LIST_COMPONENTS = createDefaultListComponents();
const DEFAULT_LIST_ITEM_COMPONENTS = createDefaultListItemComponents();

function createRichTextComponents({
  activePlaceholderKeys = [],
  components,
  includeAccordion = true,
  includeColumns = true,
  headingFont = "jakarta",
  onLinkClick,
  placeholders,
}: CreateRichTextComponentsOptions): PortableTextComponents {
  const sharedOptions = {
    activePlaceholderKeys,
    components,
    createRichTextComponents,
    headingFont,
    includeAccordion,
    includeColumns,
    onLinkClick,
    placeholders,
  };

  return mergePortableTextComponents(
    {
      block: createDefaultBlockComponents({
        activePlaceholderKeys,
        headingFont,
        placeholders,
      }),
      list: DEFAULT_LIST_COMPONENTS,
      listItem: DEFAULT_LIST_ITEM_COMPONENTS,
      marks: createDefaultMarkComponents(sharedOptions),
      types: createDefaultTypeComponents(sharedOptions),
    },
    components,
  );
}

export { createRichTextComponents };
